import { render, staticRenderFns } from "./subject-outline.vue?vue&type=template&id=880d16da&scoped=true"
import script from "./subject-outline.vue?vue&type=script&lang=js"
export * from "./subject-outline.vue?vue&type=script&lang=js"
import style0 from "./subject-outline.vue?vue&type=style&index=0&id=880d16da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "880d16da",
  null
  
)

export default component.exports